<template>
  <div class="rider-receipt-mgmt">
    <receipt-settings v-if="activeTab === 'template'" />
    <receipt-custom-print v-else />
  </div>
</template>

<script>
import ReceiptSettings from './ReceiptSettings.vue'
import ReceiptCustomPrint from './ReceiptCustomPrint.vue'

export default {
  name: 'RiderReceiptManagement',
  components: { ReceiptSettings, ReceiptCustomPrint },
  computed: {
    activeTab() {
      return String(this.$route.path || '').endsWith('/print') ? 'print' : 'template'
    }
  }
}
</script>

<style scoped>
.rider-receipt-mgmt {
  padding: 16px 20px 24px;
}
</style>
